import React from 'react'
import BoxSeriesFormAdd from '../form/BoxSeriesFormAdd'

const BoxOneOptionsHeader = ({ boxId }) => {
  return (
    <div>
        <BoxSeriesFormAdd 
            boxId={boxId}
        />
    </div>
  )
}

export default BoxOneOptionsHeader